import Head from 'next/head';

type Props = Metadata;

const MetaTag = ({ metadata }: Props) => {
  return (
    <Head>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta property="og:type" content="website" />
      {(Object.keys(metadata) as Array<keyof typeof metadata>).map((key) => (
        <meta property={key} content={metadata[key]} key={key} />
      ))}
      {metadata?.title && <title key="title">{metadata?.title}</title>}
      {metadata?.description && (
        <meta name="description" content={metadata?.description} key="description" />
      )}
      <meta property="og:type" content="website" />
    </Head>
  );
};

export default MetaTag;
